import { motion, useAnimation } from "framer-motion";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import AboutVrcScreen from "../AboutVRC/AboutVrcScreen";
import CollaborationScreen from "../CollaborationScreen/CollaborationScreen";
import ObjectiveScreen from "../ObjectiveScreen/ObjectiveScreen";
import SponsorScreen from "../SponsorScreen/SponsorScreen";
import TeamMemberScreen from "../TeamMemberScreen/TeamMemberScreen";

const variants = {
  hidden: { opacity: 0, y: 100 },
  visible: { opacity: 1, y: 0 },
};

const Components = ({ serial }) => {
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  return (
    <motion.div
      className="box"
      ref={ref}
      variants={variants}
      initial="hidden"
      animate={control}
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      {serial === 1 && <AboutVrcScreen />}
      {serial === 2 && <ObjectiveScreen />}
      {serial === 3 && <CollaborationScreen />}
      {serial === 4 && <TeamMemberScreen />}
      {serial === 5 && <SponsorScreen />}
    </motion.div>
  );
};

const VrcScreen = () => {
  return (
    <div className="bg-div">
      <Components serial={1} />
      <Components serial={2} />
      <Components serial={3} />
      <Components serial={4} />
      <Components serial={5} />
    </div>
  );
};

export default VrcScreen;
